import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs } from '../../../AbstractElements'
import HomeReport from './HomeReport'
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";

export default function ReportList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("List Of Biomarkers")} parent={t("Home")} title={t("List Of Biomarkers")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <HomeReport />
                    </Col>
                </Row>
            </Container>

        </Fragment>
    )
}
